<template>
  <div class="custom-checkbox" :class="{ 'is-invalid': hasValidation() ? validation.$error : false }">
    <label class="checkbox__input" :for="id">
      <input type="checkbox" :id="id" :checked="value" @change="emit(!localValue)" :disabled="disabled" />
      <span class="checkbox__control">
        <svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.14627 0.297158C8.00903 0.159411 7.78399 0.159411 7.64675 0.297158L3.49162 4.45128L1.35174 2.29677C1.2145 2.15851 0.990974 2.15851 0.852722 2.29677L0.102932 3.04605C-0.0343107 3.18279 -0.0343107 3.40783 0.102932 3.54557L3.23984 6.70317C3.37708 6.83991 3.60061 6.83991 3.73936 6.70317L8.89555 1.54647C9.03481 1.40872 9.03481 1.18318 8.89555 1.04493L8.14627 0.297158Z"
            fill="#747474"
          />
        </svg>
      </span>
    </label>
    <span class="radio__label" v-if="text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: ['id', 'value', 'validation', 'text', 'disabled'],
  data() {
    return {
      localValue: false,
    };
  },
  methods: {
    emit(val) {
      this.localValue = val;
      if (val) {
        this.$emit('checked', val);
      }
      this.$emit('input', val);
      this.$emit('change', val);
    },
    hasValidation() {
      return !!this.validation;
    },
  },
  created() {
    this.localValue = this.value;
  },
};
</script>

<style lang="scss" scoped>
.custom-checkbox {
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 0.5em;
  font-size: 2rem;
  color: var(--textColor);
  cursor: pointer;

  &--disabled {
    color: #eee;
  }

  .checkbox__control {
    display: inline-grid;
    width: 17px;
    height: 17px;
    border-radius: 4px;
    border: 1px solid #747474;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    svg {
      transition: transform 0.1s ease-in 25ms;
      transform: scale(0);
      transform-origin: bottom left;
    }
  }

  .checkbox__input {
    display: grid;
    grid-template-areas: 'checkbox';

    > * {
      grid-area: checkbox;
    }

    input {
      opacity: 0;
      width: 1em;
      height: 1em;
      z-index: -1;

      &:focus + .checkbox__control {
      }

      &:checked + .checkbox__control {
        background: #f4f4f4;

        svg {
          transform: scale(1);
        }
      }

      &:disabled + .checkbox__control {
        color: #eee;
      }
    }
  }
}
</style>
